import type { ReplanNudge as Nudge } from '../../../hooks/useReplanNudge'

export const NUDGE_COPY: Record<Exclude<Nudge, null>, string> = {
  routingBack: "Routing's back. Tap Re-plan for a better order.",
  offRoute: "You're off the planned route. Tap Re-plan to recalculate from here.",
}
